import { sanitizeHtml } from '@/shared/lib/html/sanitize'

export const LevelPlayIntro = ({ activity }) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(activity?.intro)
      }}
      className="text-lg md:text-base mb-10 block [&_img]:w-full [&_img]:block"
    />
  )
}
